import React from 'react'

import InputForm from './inputForm'
import TextAreaForm from './textAreaForm'
import SelectForm from './selectForm'
import { Controller } from 'react-hook-form'
import { StyledFormItem } from '../styles'
import styles from '../index.module.scss'
import Uploader from 'components/uploadFile'
import { Alert, Spin, Select } from 'antd'

const evaluateAttacheds = (attacheds, watchValues) => {
	if (!attacheds || attacheds.length === 0) return true

	return attacheds.some((group) =>
		group.every(({ key, values }) => {
			const currentValue = watchValues[key]
			if (Array.isArray(currentValue)) {
				return values.some((value) => currentValue.includes(value))
			}
			return values.includes(currentValue)
		})
	)
}

const getSelectOptions = (options) =>
	options?.map((option) => (
		<Select.Option
			key={option.id ?? option.value}
			value={option.id ?? option.value}>
			{option.name ?? option.label}
		</Select.Option>
	))

const FieldForm = ({ config, control, setValue, watchValues }) => {
	const isVisible = evaluateAttacheds(config.attacheds, watchValues)
	if (!isVisible) return null

	const {
		type,
		name,
		label,
		required,
		rules = {},
		placeholder,
		options,
		isLoading,
		allowClear,
		filterFn,
		onChange: customOnChange,
	} = config

	const resolvedRules = {
		...(required
			? { required: `Selecione ${label?.toLowerCase() ?? 'um valor'}` }
			: {}),
		...rules,
	}

	const resolvedOptions = filterFn ? filterFn(options, watchValues) : options

	switch (type) {
		case 'input':
		case 'text':
			return (
				<InputForm
					name={name}
					control={control}
					label={label}
					required={required}
				/>
			)
		case 'textarea':
			return (
				<TextAreaForm
					name={name}
					control={control}
					label={label}
					required={required}
				/>
			)

		case 'select':
		case 'multiselect':
			return (
				<SelectForm
					name={name}
					control={control}
					label={label}
					required={required}
					options={resolvedOptions}
					isLoading={isLoading}
					allowClear={allowClear}
					placeholder={placeholder}
					resolveRules={resolvedRules}
					customOnChange={customOnChange}
					watchValues={watchValues}
					resolveOptions={getSelectOptions}
					mode={type === 'multiselect' ? 'multiple' : undefined}
				/>
			)

		case 'uploader':
			const fileList = watchValues[name] ?? []
			return (
				<StyledFormItem required={required}>
					<p className={styles.label}>{label}</p>
					<Uploader
						multiple={config.multiple}
						max={config.max}
						fileList={fileList}
						setFileList={(files) => setValue(name, files)}
						allowedTypes={config.allowedTypes}
						allowedExtensions={config.allowedExtensions}
					/>
				</StyledFormItem>
			)

		case 'alert':
			const description =
				typeof config.alertDescription === 'function'
					? config.alertDescription(watchValues)
					: config.alertDescription
			if (!description) return null
			return (
				<Alert
					type={config.alertType ?? 'info'}
					showIcon
					message={config.alertMessage}
					description={description}
					style={{ whiteSpace: 'pre-line' }}
				/>
			)

		default:
			return null
	}
}

export default FieldForm
